module.exports = {
	"_args": [
		[
			{
				"raw": "truffle-contract-schema@0.0.5",
				"scope": null,
				"escapedName": "truffle-contract-schema",
				"name": "truffle-contract-schema",
				"rawSpec": "0.0.5",
				"spec": "0.0.5",
				"type": "version"
			},
			"/saveproj/koshima/oyomecoin/oyomecoin/node_modules/truffle-contract"
		]
	],
	"_cnpm_publish_time": 1485557985367,
	"_from": "truffle-contract-schema@0.0.5",
	"_hasShrinkwrap": false,
	"_id": "truffle-contract-schema@0.0.5",
	"_inCache": true,
	"_location": "/truffle-contract-schema",
	"_nodeVersion": "6.9.1",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/truffle-contract-schema-0.0.5.tgz_1485557985137_0.46875762194395065"
	},
	"_npmUser": {
		"name": "tcoulter",
		"email": "tim@timothyjcoulter.com"
	},
	"_npmVersion": "3.10.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "truffle-contract-schema@0.0.5",
		"scope": null,
		"escapedName": "truffle-contract-schema",
		"name": "truffle-contract-schema",
		"rawSpec": "0.0.5",
		"spec": "0.0.5",
		"type": "version"
	},
	"_requiredBy": [
		"/truffle-contract"
	],
	"_resolved": "http://registry.npm.taobao.org/truffle-contract-schema/download/truffle-contract-schema-0.0.5.tgz",
	"_shasum": "5e9d20bd0bf2a27fe94310748249d484eee49961",
	"_shrinkwrap": null,
	"_spec": "truffle-contract-schema@0.0.5",
	"_where": "/saveproj/koshima/oyomecoin/oyomecoin/node_modules/truffle-contract",
	"author": {
		"name": "Tim Coulter",
		"email": "tim.coulter@consensys.net"
	},
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle-schema/issues"
	},
	"dependencies": {
		"crypto-js": "^3.1.9-1"
	},
	"description": "JSON schema for contract artifacts",
	"devDependencies": {
		"mocha": "^3.2.0"
	},
	"directories": {},
	"dist": {
		"shasum": "5e9d20bd0bf2a27fe94310748249d484eee49961",
		"size": 3057,
		"noattachment": false,
		"tarball": "http://registry.npm.taobao.org/truffle-contract-schema/download/truffle-contract-schema-0.0.5.tgz"
	},
	"gitHead": "cfa4313bd4bb95bf5b94f85185203ead418f9ee6",
	"homepage": "https://github.com/trufflesuite/truffle-schema#readme",
	"keywords": [
		"ethereum",
		"json",
		"schema",
		"contract",
		"artifacts"
	],
	"license": "MIT",
	"main": "index.js",
	"maintainers": [
		{
			"name": "benjamincburns",
			"email": "benjamin.c.burns@gmail.com"
		},
		{
			"name": "cgewecke",
			"email": "christophergewecke@gmail.com"
		},
		{
			"name": "gnidan",
			"email": "nick@gnidan.org"
		},
		{
			"name": "tcoulter",
			"email": "tim@timothyjcoulter.com"
		}
	],
	"name": "truffle-contract-schema",
	"optionalDependencies": {},
	"publish_time": 1485557985367,
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/trufflesuite/truffle-schema.git"
	},
	"scripts": {
		"test": "mocha"
	},
	"version": "0.0.5"
};


//////////////////
// WEBPACK FOOTER
// ./~/truffle-contract-schema/package.json
// module id = 583
// module chunks = 0